import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { fadeOutUp, fadeOutDown } from 'react-animations';

import { Font, Flexbox, Color } from './Styles';
import ScoreCircles from './scoreCircles/ScoreCircles';

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    marginLeft: 5,
    marginRight: 5
  },
  circle: {
    height: 65,
    width: 65,
    backgroundSize: '100% 100%'
  },
  innerText: {
    fontSize: '80%',
    margin: '25%',
    height: '50%',
    width: '50%'
  },
  label: {
    textAlign: 'center'
  },
  bar: {
    height: 16,
    width: 60,
    backgroundColor: Color.primaryInverse,
    borderRadius: '6px',
    border: `3px solid ${Color.primary}`
  },
  small: {
    fontSize: '66%'
  },
  positiveDelta: {
    position: 'absolute',
    top: 0,
    right: 10,
    padding: 3,
    borderRadius: 5,
    backgroundColor: '#36BB77',
    color: 'white',
    animationName: fadeOutUp,
    animationDuration: '3s',
    animationFillMode: 'forwards'
  },
  negativeDelta: {
    position: 'absolute',
    bottom: 0,
    right: 10,
    padding: 3,
    borderRadius: 5,
    backgroundColor: '#DD5959',
    color: 'white',
    animationName: fadeOutDown,
    animationDuration: '3s',
    animationFillMode: 'forwards'
  }
});

class ScoreComponent extends Component {
    constructor(props) {
    super(props);
    this.state = { delta: null }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ delta: nextProps.value - this.props.value });
    setTimeout(() => {
      this.setState({ delta: 0 });
    }, 3000);
  }

  renderCircle(value, delta, max, prefix) {
    let imageStyleSheet = ScoreCircles.imageStyleSheetForFactor(value / max);
    let string = prefix? `${prefix}${value}` : value;
    let deltaString = `${(delta > 0)? '+' : '-'}${prefix || ""}${Math.abs(delta)}`

    return(
      <div className={css(styles.circle, imageStyleSheet.image)}>
        {delta > 0 &&
          <div className={css(styles.positiveDelta)}>{deltaString}</div>
        }
        {delta < 0 &&
          <div className={css(styles.negativeDelta)}>{deltaString}</div>
        }
        <div className={css(styles.innerText, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter)}>
          <div className={css(string.length > 4? styles.small : null)}>{string}</div>
        </div>
      </div>
    );
  }

  renderBar(value, delta, max, prefix) {
    let bar = StyleSheet.create({
      filled: {
        backgroundColor: Color.primary,
        width: `${100*value/max}%`
      }
    });
    let string = prefix? `${prefix}${value}` : value;
    let deltaString = `${(delta > 0)? '+' : '-'}${prefix || ""}${Math.abs(delta)}`

    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        {delta > 0 &&
          <div className={css(styles.positiveDelta)}>{deltaString}</div>
        }
        {delta < 0 &&
          <div className={css(styles.negativeDelta)}>{deltaString}</div>
        }
        <div className={css(Flexbox.row, Flexbox.axisStart, Flexbox.crossFill, styles.bar)}>
          <div className={css(bar.filled)}/>
        </div>
        <div>{string}</div>
      </div>
    );
  }

  render() {
    if (this.props.compact) {
      return(
        <div className={css(styles.container, Flexbox.column, Flexbox.axisEnd, Flexbox.crossCenter)}>
          <div className={css(styles.label, Font.tinyLabel)}>{this.props.label}</div>
          {this.renderBar(this.props.value, this.state.delta, this.props.max, this.props.prefix)}
        </div>
      );
    } else {
      return(
        <div className={css(styles.container, Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
          {this.renderCircle(this.props.value, this.state.delta, this.props.max, this.props.prefix)}
          <div className={css(styles.label, Font.label)}>{this.props.label}</div>
        </div>
      );
    }
  }
}

export default ScoreComponent;



// WEBPACK FOOTER //
// ./src/ScoreComponent.js